import axios from "axios";
import { getCookie } from "../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getInspectionListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `inspection?` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getInspectionEditDetailsApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `inspection/edit/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getVehicleDetailsApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `get_vehicle_details/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const submitInspectionAPI = async (body) => {
  try {
    const response = await axios.post(apiUrl + `inspection`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const updateInspectionAPI = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `inspection/` + id, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getInspectionDetailsApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `inspection/view/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getInspectionHistoryDetailsApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `inspection_history/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const saveAttachmentApi = async (id, body) => {
  try {
    const response = await axios.put(
      apiUrl + `inspection/add_attachment/` + id,
      body,
      {
        headers: header,
      }
    );
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getInspectionEditApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `inspection/edit/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getInspectionHistoryListApi = async (id, params) => {
  try {
    const response = await axios.get(apiUrl + `inspection_history_list/${id}`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
